export default "__VITE_ASSET__95daf709__";